<div class="w-100" [formGroup]="formGroup">
  <div class="d-flex flex-row justify-content-between align-items-center mx-3">
    <h2 class="title">{{isEdit ? 'Edit Scorecard Setting' : 'Add Scorecard Setting'}}</h2>
    <div class="btn btn-primary d-flex justify-content-center align-items-center btn-add button"(click)="save()">
      Save
    </div>
  </div>
  <div class="mt-3 container px-0">
    <div class="d-flex flex-row justify-content-between row m-0">
      <div class="d-flex flex-row align-items-center col-xl-3 col-lg-6 col-md-6 p-1 filter-width">
        <span style="transform: translateY(-4px); width: 80px;">Type: </span>
        <mat-form-field floatLabel="never" appearance="outline" >
          <mat-select formControlName="type" required>
            <mat-option [value]="0">Default setting</mat-option>
            <mat-option [value]="1">Parent Company</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="d-flex flex-row align-items-center col-xl-3 col-lg-6 col-md-6 p-1 filter-width" >
        <div class="text-normal p-0" style="transform: translateY(-4px); width: 80px;">Parent Company:
          <span style="color: red;">*</span>
        </div>
        <app-lazyload-multiple-select  [data]="parentNames" (result)="getResultFiltered('parent', $event)" [values]="parents"
        [defaultAll]="false" [disabled]="formGroup.controls.type.value === 0 || formGroup.controls.parentNames.disabled"
        >
        </app-lazyload-multiple-select>
      </div>
      <div class="d-flex flex-row align-items-center col-xl-3 col-lg-6 col-md-6 p-1 filter-width">
        <div class="text-normal p-0" style="transform: translateY(-4px); width: 80px;">GSL Number:
        </div>
        <app-lazyload-multiple-select class="" [data]="gsls" (result)="getResultFiltered('gsl', $event)" [values]="gslValues"
        [defaultAll]="false" [disabled]="formGroup.controls.type.value === 0 || formGroup.controls.parentNames.disabled"
        >
        </app-lazyload-multiple-select>
      </div>
      <div class="d-flex flex-row align-items-center col-xl-3 col-lg-6 col-md-6 p-1 filter-width">
        <div class="text-normal pr-2" style="transform: translateY(-4px); width: 80px;">Year:
          <span style="color: red;">*</span>
        </div>
        <mat-form-field appearance="outline">
          <input matInput [owlDateTimeTrigger]="dt" [owlDateTime]="dt" formControlName="year" readonly style="cursor: pointer;">
          <owl-date-time [pickerType]="'calendar'" [startView]="'multi-years'" (yearSelected)="chosenYearHandler($event, dt)"
             #dt="owlDateTime"></owl-date-time>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="mt-3">
    <table class="container">
      <tr style="border: 1px solid grey">
        <th class="w-30"></th>
        <th colspan="5" class="w-40 text-center" style="font-size: 18px;">Range / Color Code</th>
        <th colspan="3" class="w-30 text-center" style="font-size: 18px;">Scoring (Weighted)</th>
      </tr>
      <tr style="border: 1px solid grey">
        <td class></td>
        <td colspan="2" class="text-center green font-weight-bold" style="border: 1px solid grey">Exceed</td>
        <td class="text-center orange font-weight-bold" style="border: 1px solid grey">Meet</td>
        <td colspan="2" class="text-center red font-weight-bold" style="border: 1px solid grey">Below</td>
        <td class="text-center red font-weight-bold" style="border: 1px solid grey">Below</td>
        <td class="text-center orange font-weight-bold" style="border: 1px solid grey">Meets</td>
        <td class="text-center green font-weight-bold" style="border: 1px solid grey">Exceeds</td>
      </tr>
      <ng-container *ngFor="let item of kpiAccessment; let index">
        <tr style="border: 1px solid grey"></tr>
        <tr *ngFor="let kpi of item[getKeys(item)]" style="border: 1px solid grey" [formGroupName]="kpi.formGroupName">
          <td class="text-left pl-5">{{ kpi.name }} <span style="color: red;">*</span> </td>
          <td class="text-center">
            <mat-form-field floatLabel="never" style="width: 40px">
              <mat-select formControlName="rangeExceedOperator">
                <mat-option *ngFor="let cond of getKeys(conditions)" [value]="parseInt(cond)">
                  {{conditions[cond]}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </td>
          <td class="text-center">
            <mat-form-field style="width:40px">
              <input matInput numeric [decimals]="1" [negative]="1" formControlName="rangeMeetExceed">
            </mat-form-field>
          </td>
          <td></td>
          <td class="text-center">
            <mat-form-field floatLabel="never" style="width:40px">
              <mat-select formControlName="rangeBelowOperator">
                <mat-option *ngFor="let cond of getKeys(conditions)" [value]="parseInt(cond)">
                  {{conditions[cond]}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </td>
          <td class="text-center">
            <mat-form-field style="width:40px">
              <input matInput numeric [decimals]="1" [negative]="1" formControlName="rangeMeetBelow">
            </mat-form-field>
          </td>
          <td class="text-center">
            <mat-form-field style="width:40px" >
              <input matInput numeric [decimals]="1" [negative]="1" formControlName="scoringBelow">
            </mat-form-field>
          </td>
          <td class="text-center">
            <mat-form-field style="width:40px" >
              <input matInput numeric [decimals]="1" [negative]="1"  formControlName="scoringMeet">
            </mat-form-field>
          </td>
          <td class="text-center">
            <mat-form-field style="width:40px" >
              <input matInput numeric [decimals]="1" [negative]="1" formControlName="scoringExceed">
            </mat-form-field>
          </td>
        </tr>
      </ng-container>
    </table>
  </div>
</div>